import ModalProduct from './ModalProduct'

export default ModalProduct
